<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <AmDataTableMenu @methodEnum='methodEnum'></AmDataTableMenu>
      <AmDataTable ref="amdataTable"></AmDataTable>
    </template>
  </BasicLayout>
</template>

<script>
import AmDataTable from '../../../../components/subscriberconfig/udmSubscriber/amdata/AmDataTable';
import AmDataTableMenu from '../../../../components/subscriberconfig/udmSubscriber/amdata/AmDataTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'AmDataMainPage',
  components: {
    NeList,
    AmDataTable,
    AmDataTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("AmData.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.amdataTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.amdataTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.amdataTable.delProfiles();
          break;
        case 'qry':
          this.$refs.amdataTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.amdataTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
